// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ct-confirm-step section.ct-wizard-section-header {
  width: 70%;
}
.ct-confirm-step .ct-confirm-step-actions {
  width: 70%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/ConfirmationStep/index.scss"],"names":[],"mappings":"AACE;EACE,UAAA;AAAJ;AAGE;EACE,UAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADJ","sourcesContent":[".ct-confirm-step {\n  section.ct-wizard-section-header {\n    width: 70%;\n  }\n\n  .ct-confirm-step-actions {\n    width: 70%;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: row;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
